import {Component, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {Template} from "../../../model/template";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {TemplatesService} from "../../../services/templates.service";

@Component({
  selector: 'app-templates-details',
  templateUrl: './templates-details.component.html',
  styleUrls: ['./templates-details.component.scss']
})
export class TemplatesDetailsComponent implements OnInit {

  public navState: any;

  public template: Template;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private templatesService: TemplatesService,
              private translocoService: TranslocoService) {
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadTemplate(params.uuid));

    this.items = [
      {id: 'overview', label: 'common.overview', icon: 'pi pi-home'},
      {id: 'sensors', label: 'model.sensors', icon: 'pi pi-wifi'},
      {id: 'properties', label: 'model.properties', icon: 'pi pi-bars'}
    ];
    this.loadItems();
  }

  loadTemplate(templateUuid: string): void {
    this.templatesService.getTemplate(templateUuid).subscribe(response => {
      this.template = response.template;
      if (this.template.type === 'DEVICE') {
        this.items.splice(3, 0, {id: 'integrationModules', label: 'model.integrationModules', icon: 'pi pi-table'});
        this.items.forEach(item => {
          this.translocoService.selectTranslate(item.label).subscribe(value => {
            return item.label = value;
          });
        });
      }
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

  private loadItems() {
    this.items.forEach(item => {
      this.translocoService.selectTranslate(item.label).subscribe(value => {
        return item.label = value;
      });
    });

    if (this.navState && this.navState.showView) {
      this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
      this.activeItem = this.items[this.activeItemIndex];
    } else {
      this.activeItemIndex = 0;
      this.activeItem = this.items[this.activeItemIndex];
    }
  }
}
